import type { Events } from '~/plugins/emitter'

export default function submitFormData(data: Events['submit-form-data']) {
  return {
    event: 'submit-data',
    phone: data.phone?.replace(/\D/g, ''),
    email: data.email,
  }
}
